import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { BaseService } from 'app/core/base.service';
import { Shipment } from './shipment';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class ShipmentService {
	private static readonly BASE_URL: string = BaseService.HOST + '/shipments';

	constructor(
		private http: HttpClient,
		private fb: FormBuilder
	) {}

	getById(id: number, params?: HttpParams): Observable<Shipment> {
		return this.http.get(ShipmentService.BASE_URL + '/' + id, {params: params})
			.pipe(
				map(BaseService.extractData),
				catchError(BaseService.handleError)
			);
	}

	getAll(params: HttpParams): Observable<any> {
		return this.http.get(ShipmentService.BASE_URL, {params: params})
			.pipe(catchError(BaseService.handleError));
	}

	create(shipment: Shipment): Observable<Shipment> {
		return this.http.post(ShipmentService.BASE_URL, shipment)
			.pipe(
				map(BaseService.extractData),
				catchError(BaseService.handleError)
			);
	}

	update(shipment: Shipment): Observable<Shipment> {
		return this.http.put(ShipmentService.BASE_URL + '/' + shipment.id, shipment)
			.pipe(
				map(BaseService.extractData),
				catchError(BaseService.handleError)
			);
	}

	delete(id: number): Observable<any> {
		return this.http.delete(ShipmentService.BASE_URL + '/' + id)
			.pipe(catchError(BaseService.handleError));
	}

	toFormGroup(shipment: Shipment): FormGroup {
		return this.fb.group({
			id: new FormControl(shipment.id),
			tracking: new FormControl(shipment.tracking, Validators.required),
			description: new FormControl(shipment.description),
			statusShipment: new FormControl(shipment.statusShipment ? {id: shipment.statusShipment.id} : undefined, Validators.required),
			partOrder: new FormControl(shipment.partOrder ? {id: shipment.partOrder.id} : undefined, Validators.required),
		});
	}
}
